/** Branches, warehouses and registers (docs/specs/locations.md). */
export const locations = {
    title: "Locations",
    description: "Your branches (shops that sell) and warehouses (stock only).",
    add: "Add location",
    edit: "Edit location",
    back: "All locations",
    columns: { name: "Name", type: "Type", billPrefix: "Bill prefix", status: "Status" },
    types: { branch: "Branch", warehouse: "Warehouse" },
    statuses: { active: "Active", inactive: "Inactive" },
    filters: { type: "Type", status: "Status", all: "All" },
    isDefault: "Default for online orders",
    fields: {
        type: "Type",
        name: "Name",
        billPrefix: "Bill prefix",
        billPrefixHint: "1–6 letters or digits, printed on POS bills (e.g. B1).",
        address: "Address",
        phone: "Phone",
        receiptHeader: "Receipt header",
        receiptHeaderHint: "Printed at the top of this branch's receipts.",
        shopVisible: "Show on the online shop",
        shopVisibleHint: "Shoppers see this branch's name, address, phone and hours in “Our shops”.",
        openingHours: "Opening hours",
        openingHoursHint: "As shoppers should read it, e.g. Sat–Thu 10:00–21:00",
        mapUrl: "Map link",
        mapUrlHint: "A Google Maps (or any https://) link for directions.",
    },
    empty: "No locations yet. Add your first branch.",
    created: "Location added.",
    saved: "Location saved.",
    makeDefault: "Make default for online orders",
    madeDefault: "Default location changed.",
    deactivate: "Deactivate",
    activate: "Activate",
    deactivateTitle: "Deactivate this location?",
    deactivateBody: "Its registers are deactivated too. Its history stays in reports.",
    deactivated: "Location deactivated.",
    activated: "Location activated.",
    conflict: "Someone else changed this location. The latest values are shown; make your change again.",
    registers: {
        title: "Registers",
        description: "Cash counters in this branch. Each POS computer is bound to one.",
        name: "Register name",
        add: "Add register",
        added: "Register added.",
        rename: "Rename",
        renamed: "Register renamed.",
        deactivated: "Register deactivated.",
        activated: "Register activated.",
        empty: "No registers yet.",
        warehouse: "Warehouses have no registers.",
    },
};
//# sourceMappingURL=locations.js.map